module.exports = __webpack_public_path__ + "media/icon/icon-autorenew-4dbdda06.svg";